module.exports = __webpack_public_path__ + "static/media/logo monoquick.8a612523.png";